/** Rota da janela "Ver na tela" (S36-D4). O id do relatorio e os filtros vao na URL; a janela busca os dados de novo. */
export const ROTA_VER_NA_TELA = '/relatorio';

/** Limite de chaves de filtro aceitas na URL (protege a rota de lixo). */
const MAX_FILTROS = 30;
const MAX_TEXTO = 200;

/** URL da janela: `rel` = id do relatorio e um parametro por filtro preenchido (vazio = ausente). */
export function urlVerNaTela(id: string, params: Record<string, string | undefined>): string {
  const q = new URLSearchParams();
  q.set('rel', id);
  for (const [chave, valor] of Object.entries(params)) {
    if (chave !== 'rel' && valor) q.set(chave, valor);
  }
  return `${ROTA_VER_NA_TELA}?${q.toString()}`;
}

/**
 * `validateSearch` da rota: `rel` e os filtros como texto. O router faz JSON.parse da URL, entao `?q=10874` chega como numero:
 * numero e booleano viram texto de novo. O que nao for texto nem numero e descartado.
 */
export function lerBuscaVerNaTela(bruto: Record<string, unknown>): { rel: string } & Record<string, string> {
  const rel = typeof bruto.rel === 'string' || typeof bruto.rel === 'number' ? String(bruto.rel).slice(0, 80) : '';
  const saida: { rel: string } & Record<string, string> = { rel };
  let n = 0;
  for (const [chave, valor] of Object.entries(bruto)) {
    if (chave === 'rel' || n >= MAX_FILTROS) continue;
    const texto = typeof valor === 'string' ? valor : typeof valor === 'number' || typeof valor === 'boolean' ? String(valor) : '';
    if (!texto.trim()) continue;
    saida[chave] = texto.slice(0, MAX_TEXTO);
    n += 1;
  }
  return saida;
}

/** Filtros (sem `rel`) de uma busca lida pela rota: o que vai para `params` do relatorio. */
export function filtrosDaBusca(busca: { rel: string } & Record<string, string>): Record<string, string> {
  const { rel: _rel, ...filtros } = busca;
  return filtros;
}
